import { Icon, IconProps } from '@chakra-ui/react';
import colors from 'src/theme/colors';

export function LeftArrow({ color = colors.podcastShade500, ...props }: IconProps) {
  return (
    <Icon {...props} color={color} w="13px" h="12px">
      <svg viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/Icon">
        <path
          d="M6 1 1 6m0 0 5 5M1 6h11"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </Icon>
  );
}
